import * as React from 'react';

const PageMobileWrapper = (props) => {
  const { className } = props;
  
  return (
    <div className={`m__cont__content ` + (props.className ? props.className : '')}>
      {props.children}
    </div>
  )
};

export default PageMobileWrapper;
